import { render } from "./SettingPage.vue?vue&type=template&id=6c683cc7&scoped=true"
import script from "./SettingPage.vue?vue&type=script&lang=js"
export * from "./SettingPage.vue?vue&type=script&lang=js"

import "./SettingPage.vue?vue&type=style&index=0&id=6c683cc7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3094357117/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c683cc7"]])

export default __exports__